import { ProductType } from "creso-core/types";
import { Badge, cn } from "web-design-system";

export function ProductTypeBadge({
  type,
  className,
}: {
  type: ProductType;
  className?: string;
}) {
  if (type === "MF") return null;

  return (
    <Badge
      variant="custom"
      className={cn(className, {
        "bg-tag-orange text-tag-orange-foreground": type === "GIFT",
        "bg-tag-red text-tag-red-foreground": type === "SIF",
      })}
    >
      {type}
    </Badge>
  );
}
